import {createStore, applyMiddleware, compose} from 'redux'

import thunk from 'redux-thunk';
import reducer from "./reducer.js"

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose, middleware = [thunk];

export const store = createStore(
    reducer,
    composeEnhancers(applyMiddleware(...middleware))
);


// WEBPACK FOOTER //
// ./src/redux/store.js